import { render } from "./ModalWarn.vue?vue&type=template&id=21a70b7e&scoped=true"
import script from "./ModalWarn.vue?vue&type=script&lang=js"
export * from "./ModalWarn.vue?vue&type=script&lang=js"

import "./ModalWarn.vue?vue&type=style&index=0&id=21a70b7e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a70b7e"]])

export default __exports__